import api from '../api/api';
import Issue, { IssueScope, IssueStatus } from '../../types/Issue';

interface ListIssuesParams {
  query?: string;
  status?: IssueStatus | null;
  scope?: IssueScope | null;
  page: number;
  resultsPerPage: number;
  sortColumn?: string;
  sortDirection?: 'ASC' | 'DESC';
  signal?: AbortSignal;
}

interface IssueSearchResult {
  numberOfResults: number;
  results: Issue[];
}

class IssueService {
  static async listIssues({
    query,
    status,
    scope,
    page,
    resultsPerPage,
    sortColumn = 'reference',
    sortDirection = 'ASC',
    signal
  }: ListIssuesParams): Promise<IssueSearchResult> {
    const params = new URLSearchParams();
    if (query) params.append('query', query);
    if (status) params.append('status', status);
    if (scope) params.append('scope', scope);
    params.append('page', page.toString());
    params.append('size', resultsPerPage.toString());
    params.append('sort', `${sortColumn},${sortDirection}`);

    const apiResponse = await api.get(
      `admin/issues?${params}`,
      signal ? { signal } : {}
    );
    return {
      numberOfResults: apiResponse.data.totalElements ?? 0,
      results: apiResponse.data.content ?? []
    };
  }

  static async updateIssue(
    id: number,
    title: string,
    description: string,
    notes: string,
    status: IssueStatus
  ): Promise<Issue> {
    const apiResponse = await api.put<Issue>(`admin/issues/${id}`, {
      title,
      description,
      notes,
      status
    });
    return apiResponse.data;
  }

  static async resolveIssue(id: number): Promise<Issue> {
    const apiResponse = await api.post<Issue>(`admin/issues/${id}/resolve`);
    return apiResponse.data;
  }

  static async deleteIssue(id: number): Promise<void> {
    await api.delete(`admin/issues/${id}`);
  }
}

export default IssueService;
